module.exports = __webpack_public_path__ + "img/sort-numeric-up.fe5eed64.svg";